import React from 'react'
import CircleIcon from '../../icons/CircleIcon'
import AbacusIcon from '../../icons/AbacusIcon'
import IndustryIcon from '../../icons/IndustryIcon'
import DiamondIcon from '../../icons/DiamondIcon'

const getAvatar = function (label) {
  switch (label) {
    case 'Firma':
      return {
        Icon: IndustryIcon,
        iconColorClass: 'avatarColorFirma',
      }
    case 'Biuro rachunkowe':
      return {
        Icon: AbacusIcon,
        iconColorClass: 'avatarColorBiuro',
      }
    default:
      return {
        Icon: DiamondIcon,
        iconColorClass: 'avatarColorPremium',
      }
  }
}

export default function WariantLicencjiAwatar({ wersja }) {
  const { Icon, iconColorClass } = getAvatar(wersja)
  return (
    <span className='avatarContainer'>
      <CircleIcon className={'avatarBackground ' + iconColorClass} />
      <Icon className={'avatarIcon ' + iconColorClass} />
    </span>
  )
}
